import React from "react";

const POSTS = [
  { title: "How LTL pricing really works — and where shippers overpay", cat: "Freight 101", date: "Feb 12, 2026", excerpt: "A field-tested breakdown of NMFC classes, base rates, and the discounts that actually move." },
  { title: "Cross-border 2026: What's changing at the US–Mexico ports", cat: "Cross-Border", date: "Feb 6, 2026", excerpt: "New CBP protocols, ACE filings, and how to keep your Laredo lanes moving." },
  { title: "Choosing a TMS in 2026: A practical shipper's checklist", cat: "Technology", date: "Jan 28, 2026", excerpt: "The 12 questions to ask any TMS vendor before signing a contract." },
  { title: "Cold chain: 7 mistakes that quietly destroy reefer freight", cat: "Cold Chain", date: "Jan 20, 2026", excerpt: "Temperature excursions, pre-cool errors, and continuous monitoring that actually helps." },
  { title: "Building a carrier scorecard your operations team will use", cat: "Operations", date: "Jan 12, 2026", excerpt: "The four metrics that separate reliable partners from headaches." },
  { title: "Freight fraud is up 400%. Here's how we screen carriers.", cat: "Compliance", date: "Jan 4, 2026", excerpt: "Inside Apex's carrier vetting: MC checks, insurance verification, and behavioral screens." },
];

export default function Blog() {
  return (
    <div>
      <section className="bg-[#0B3D6E] text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="font-label text-xs text-[#2E7BC7]">Insights</div>
          <h1 className="mt-3 font-display font-black text-4xl md:text-6xl">Field notes from the freight world.</h1>
        </div>
      </section>
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {POSTS.map((p) => (
            <article key={p.title} className="border border-gray-200 rounded-lg p-7 hover:-translate-y-1 hover:border-[#2E7BC7]/40 transition-all cursor-pointer" data-testid={`blog-post-${p.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
              <div className="font-label text-xs text-[#2E7BC7]">{p.cat}</div>
              <h3 className="mt-3 font-display font-bold text-lg text-[#0B3D6E] leading-snug">{p.title}</h3>
              <p className="mt-3 text-sm text-slate-600">{p.excerpt}</p>
              <div className="mt-6 text-xs text-slate-500">{p.date}</div>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}
